// src/components/Navbar.js
import React from "react";
import { Link, NavLink } from "react-router-dom";

export default function Navbar() {
  const getLinkClass = ({ isActive }) =>
    "nav-link" + (isActive ? " nav-link-active" : "");

  return (
    <header className="nav-wrapper">
      <div className="container nav-inner">
        {/* Brand */}
        <Link to="/" className="brand brand-with-logo">
  <img
    src="/assets/platinum-palm-logo.png"
    alt="Platinum Palm Properties"
    className="brand-logo"
  />
</Link>

        {/* Links */}
        <nav className="nav-links">
          <NavLink to="/" className={getLinkClass} end>
            Home
          </NavLink>
          <NavLink to="/listings" className={getLinkClass}>
            Listings
          </NavLink>
          <NavLink to="/agents" className={getLinkClass}>
            Agents
          </NavLink>
          <NavLink to="/about" className={getLinkClass}>
            About
          </NavLink>
          <NavLink to="/contact" className={getLinkClass}>
            Contact
          </NavLink>
         <Link to="/sell" className="nav-cta">
          List Your Home
        </Link>
        </nav>

     </div>
    </header>
  );
}
